<template>
  <div class="login-layout">
    <router-view />
  </div>
</template>

<script>
import { onMounted } from 'vue'

import { loadScript, loadStyle } from '@/utils/scriptLoader'

export default {
async mounted() {
  /*loadStyle('/css/login/login.css')
  await loadScript('https://code.jquery.com/jquery-3.6.0.min.js')
  await loadScript('/js/login/login.js')
  await loadScript('/js/formValidations.js')*/
} 
}
</script>
